import InternalTransportBaseScreen from "../../shared/internalTransport/InternalTransportBaseScreen";

export const ProcessInternalTransportBase = ({ modalData }: { modalData: any }) => (
  <InternalTransportBaseScreen modalData={modalData} gate="process" variant="mapping" />
);
